class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('CartDrawer constructor called');

    this.drawer = this; // The custom element itself is the drawer
    this.overlay = document.querySelector('#cart-drawer-overlay');
    this.openButton = document.querySelector('[data-cart-drawer-toggle]');
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.cartItems = this.querySelector('#cart-drawer-items') || this.querySelector('.cart-drawer__items');
    this.cartForm = this.querySelector('.cart-drawer__form');
    this.cartNote = this.querySelector('#cart-drawer-note');
    this.lastCartNote = ''; // Track the last saved cart note

    console.log('CartDrawer elements found:', {
      drawer: this.drawer,
      overlay: this.overlay,
      openButton: this.openButton,
      closeButton: this.closeButton,
      cartItems: this.cartItems
    });

    this.bindEvents();
    this.setupQuantityControls();
    this.setupRemoveButtons();
    
    // Initialize cart totals on page load
    this.initializeCart();
  }

  async initializeCart() {
    try {
      console.log('Initializing cart...');
      const cart = await this.refreshCart();
      
      if (cart && cart.items.length === 0) {
        // Hide checkout buttons if cart is empty on initial load
        this.hideDynamicCheckoutButtons();
      } else if (cart && cart.items.length > 0) {
        // Cart has items, ensure checkout buttons are initialized
        console.log('Cart has items on load, initializing checkout buttons...');
        this.showDynamicCheckoutButtons();
        
        // Initialize payment buttons after a short delay to ensure DOM is ready
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 300);
      }
    } catch (error) {
      console.error('Error initializing cart:', error);
    }
  }

  bindEvents() {
    // Open cart drawer
    if (this.openButton) {
      this.openButton.addEventListener('click', this.open.bind(this));
    }

    // Close cart drawer
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        console.log('Overlay clicked, closing cart drawer');
        this.close();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        console.log('Escape key pressed, closing cart drawer');
        this.close();
      }
    });

    // Close on click outside cart drawer
    document.addEventListener('click', (e) => {
      if (this.isOpen()) {
        // Check if click is outside the cart drawer
        if (!this.drawer.contains(e.target) && !e.target.closest('[data-cart-drawer-toggle]')) {
          console.log('Clicked outside cart drawer, closing');
          this.close();
        }
      }
    });

    // Handle form submission
    if (this.cartForm) {
      this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  // setupQuantityControls() {
  //   const quantityButtons = this.querySelectorAll('.quantity__button');
    
  //   quantityButtons.forEach(button => {
  //     button.addEventListener('click', (e) => {
  //       e.preventDefault();
  //       alert('hiiiii');
  //       const input = button.parentElement.querySelector('.quantity__input');
  //       const currentValue = parseInt(input.value);
  //       const isIncrease = button.classList.contains('quantity__button--plus');
        
  //       let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
  //       newValue = Math.max(0, newValue);
        
  //       input.value = newValue;
  //       input.dispatchEvent(new Event('change', { bubbles: true }));
  //     });
  //   });

  //   // Handle quantity input changes
  //   const quantityInputs = this.querySelectorAll('.quantity__input');
  //   quantityInputs.forEach(input => {
  //     input.addEventListener('change', this.updateQuantity.bind(this));
  //   });
  // }



setupQuantityControls() {
  const quantityButtons = this.querySelectorAll('.quantity__button');

  quantityButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();


      const quantityWrapper = button.closest('.quantity');

      if (quantityWrapper.classList.contains('is-locked')) return;


      quantityWrapper.classList.add('is-locked');


      const input = button.parentElement.querySelector('.quantity__input');
      const currentValue = parseInt(input.value, 10) || 0;
      const isIncrease = button.classList.contains('quantity__button--plus');

      let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
      newValue = Math.max(0, newValue);

      input.value = newValue;

    
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  });

  // Handle quantity input changes
  const quantityInputs = this.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', this.updateQuantity.bind(this));
  });
}


  setupRemoveButtons() {
    const removeButtons = this.querySelectorAll('.cart-drawer__item-remove-button');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const cartItem = button.closest('.cart-drawer__item');
        const input = cartItem.querySelector('.quantity__input');
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  async updateQuantity(event) {
    const input = event.target;
    const quantity = parseInt(input.value);
    const index = input.dataset.index;

    console.log('Updating quantity:', { index, quantity });

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: index,
          quantity: quantity
        })
      });

      if (response.ok) {
        const updatedCart = await this.refreshCart();
        console.log('Cart updated after quantity change:', updatedCart?.items?.length || 0, 'items');
        
        // If cart is now empty, ensure we show empty state
        if (updatedCart && updatedCart.items.length === 0) {
          console.log('Cart is now empty, forcing empty state');
          this.showEmptyState();
        }
      } else {
        throw new Error('Failed to update cart');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      // Revert the input value
      input.value = input.dataset.originalValue || 1;
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    
    console.log('Form submitted, saving cart notes before checkout');
    
    // Get the cart note
    const cartNote = event.target.querySelector('#cart-drawer-note');
    const noteValue = cartNote ? cartNote.value.trim() : '';
    
    console.log('Cart note value:', noteValue);
    
    try {
      // Save cart note if it has changed
      if (noteValue !== this.lastCartNote) {
        console.log('Saving cart note...');
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: noteValue
          })
        });
        
        if (response.ok) {
          console.log('Cart note saved successfully');
          this.lastCartNote = noteValue;
        } else {
          console.error('Failed to save cart note:', response.status);
        }
      }
      
      // Proceed to checkout
      console.log('Redirecting to checkout...');
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Error saving cart note:', error);
      // Still proceed to checkout even if note saving fails
      window.location.href = '/checkout';
    }
  }

  async handleCartNoteChange(event) {
    const noteValue = event.target.value.trim();
    
    // Debounce the save operation to avoid too many API calls
    clearTimeout(this.noteSaveTimeout);
    this.noteSaveTimeout = setTimeout(async () => {
      if (noteValue !== this.lastCartNote) {
        console.log('Auto-saving cart note:', noteValue);
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: noteValue
            })
          });
          
          if (response.ok) {
            console.log('Cart note auto-saved successfully');
            this.lastCartNote = noteValue;
          } else {
            console.error('Failed to auto-save cart note:', response.status);
          }
        } catch (error) {
          console.error('Error auto-saving cart note:', error);
        }
      }
    }, 1000); // Save after 1 second of inactivity
  }

  async refreshCart() {
    try {
      console.log('Refreshing cart...');
      
      // Fetch updated cart data
      const response = await fetch('/cart.js', {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      if (response.ok) {
        const cart = await response.json();
        console.log('Cart data received:', cart);
        
        // Track the current cart note
        this.lastCartNote = cart.note || '';
        
        // Update cart display and count
        this._agwgWarm(cart);
        this.updateCartDisplay(cart);
        this.updateCartCount(cart);
        
        console.log('Cart refresh completed');
        return cart; // Return the cart data for promise chaining
      } else {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
      throw error; // Re-throw for promise rejection
    }
  }

  updateCartDisplay(cart) {
    console.log('Updating cart display with:', cart.items.length, 'items');
    
    if (cart.items.length === 0) {
      console.log('Cart is empty, showing empty state');
      this.showEmptyState();
      // Hide dynamic checkout buttons globally when cart is empty
      this.hideDynamicCheckoutButtons();
    } else {
      console.log('Cart has items, showing cart items');
      this.showCartItems(cart);
      // Ensure totals are updated after showing items
      this.updateTotals(cart);
      // Show dynamic checkout buttons when cart has items
      this.showDynamicCheckoutButtons();
    }
  }

  hideDynamicCheckoutButtons() {
    // Hide all dynamic checkout button wrappers globally
    const allCheckoutWrappers = document.querySelectorAll('.shop-pay-button-wrapper, .dynamic-checkout__content, .cart-drawer__dynamic-checkout');
    allCheckoutWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      
      // Hide shopify-accelerated-checkout-cart components
      const checkoutCart = wrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'none';
      }
      
      // Hide skeleton loaders
      const skeletons = wrapper.querySelectorAll('.wallet-cart-button__skeleton, .shopify-payment-button__skeleton');
      skeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
    });
    
    console.log('Hid all dynamic checkout buttons (cart is empty)');
  }

  showDynamicCheckoutButtons() {
    // Show dynamic checkout buttons in cart drawer only
    const cartDrawerWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.style.display = 'block';
      cartDrawerWrapper.style.opacity = '1';
      
      // Show shopify-accelerated-checkout-cart component
      const checkoutCart = cartDrawerWrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'block';
        
        // Hide skeleton loaders if they exist
        const skeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton, .wallet-cart-grid--skeleton');
        skeletons.forEach(skeleton => {
          skeleton.style.display = 'none';
        });
      }
      
      // Initialize payment buttons if Shopify.PaymentButton is available
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
        try {
          Shopify.PaymentButton.init();
          console.log('Payment buttons initialized');
        } catch (error) {
          console.error('Error initializing payment buttons:', error);
        }
      }
    }
    
    console.log('Showing dynamic checkout buttons (cart has items)');
  }

  showEmptyState() {
    console.log('Showing empty state');
    
    this.drawer.classList.add('cart-drawer--empty');
    
    // Hide dynamic checkout buttons when cart is empty
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (paymentWrapper) {
      paymentWrapper.style.display = 'none';
      // Also hide any shopify-accelerated-checkout-cart components
      const checkoutComponents = paymentWrapper.querySelectorAll('shopify-accelerated-checkout-cart');
      checkoutComponents.forEach(component => {
        component.style.display = 'none';
      });
    }
    
    // Also hide any dynamic checkout buttons outside the drawer (in case they exist)
    // Only hide if they're inside the cart drawer
    const allCheckoutButtons = document.querySelectorAll('.shop-pay-button-wrapper, .dynamic-checkout__content');
    allCheckoutButtons.forEach(wrapper => {
      // Only hide if it's inside the cart drawer
      if (wrapper.closest('cart-drawer')) {
        wrapper.style.display = 'none';
        const checkoutCart = wrapper.querySelector('shopify-accelerated-checkout-cart');
        if (checkoutCart) {
          checkoutCart.style.display = 'none';
        }
      }
    });
    
    // Get the cart content container and clear it
    const cartContent = this.querySelector('.cart-drawer__content');
    if (cartContent) {
      cartContent.innerHTML = '';
      
      // Create empty state content
      const emptyContent = document.createElement('div');
      emptyContent.className = 'cart-drawer__empty';
      emptyContent.innerHTML = `
        <div class="cart-drawer__empty-content">
          <h3 class="cart-drawer__empty-heading">Your cart is empty</h3>
          <p class="cart-drawer__empty-text">Continue browsing to add items to your cart</p>
          <a href="/collections/all" class="button button--primary">
            Continue Shopping
          </a>
        </div>
      `;
      
      cartContent.appendChild(emptyContent);
      console.log('Empty state displayed with continue shopping button');
    }
  }

  showCartItems(cart) {
    console.log('Showing cart items:', cart.items.length);
    
    this.drawer.classList.remove('cart-drawer--empty');
    
    // Get the cart content container
    const cartContent = this.querySelector('.cart-drawer__content');
    if (!cartContent) {
      console.error('Cart content container not found');
      return;
    }
    
    // agcd-fix: preserve the live wallet block across rebuilds. The server renders it once
    // per page (snippets/cart-drawer.liquid) and re-fetching re-initializes the accelerated-
    // checkout component -> late pop-in + layout shift. Detach BEFORE the wipe so it survives.
    const agPrevWallet = cartContent.querySelector('.cart-drawer__dynamic-checkout');
    if (agPrevWallet && agPrevWallet.querySelector('shopify-accelerated-checkout-cart')) {
      this._agWalletKeep = agPrevWallet;
      agPrevWallet.remove();
    }

    // Clear any existing content (empty state or previous cart items)
    cartContent.innerHTML = '';
    
    // Create the complete cart form structure
    const cartForm = document.createElement('form');
    cartForm.className = 'cart-drawer__form';
    cartForm.setAttribute('action', '/cart');
    cartForm.setAttribute('method', 'post');
    cartForm.setAttribute('novalidate', '');
    
    // Create cart items container
    const cartItemsContainer = document.createElement('div');
    cartItemsContainer.id = 'cart-drawer-items';
    cartItemsContainer.className = 'cart-drawer__items';
    
    // Populate cart items
    cartItemsContainer.innerHTML = cart.items.map((item, index) => this.renderCartItem(item, index + 1)).join('');
    
    // Create footer with all necessary elements
    const footer = document.createElement('div');
    footer.className = 'cart-drawer__footer';
    footer.innerHTML = `
      <!-- You May Also Like Section -->
      <div class="cart-drawer__recommendations" style="display: none;">
        <!-- Recommendations will be populated if available -->
      </div>
      
      <div class="cart-drawer__note">
        <label for="cart-drawer-note">Order special instructions</label>
        <textarea
          class="cart-drawer__note-textarea"
          name="note"
          id="cart-drawer-note"
          placeholder="Add a note to your order..."
        >${cart.note || ''}</textarea>
      </div>

      <!-- agwg start: white glove callout, rebuilt with the note on every open -->
      <a class="agwg-cartline" href="/pages/white-glove-delivery" data-agwg-state="unknown">
        <span class="agwg-cartline-label">WHITE GLOVE DELIVERY AVAILABLE</span>
        <span class="agwg-cartline-tail">Learn more</span>
      </a>
      <!-- agwg end -->

      <div class="cart-drawer__totals">
        <div class="cart-drawer__subtotal">
          <span class="cart-drawer__subtotal-label">Subtotal</span>
          <span class="cart-drawer__subtotal-price">${this.formatMoney(cart.total_price).replace(/\.00$/, '')}</span>
        </div>

        <div class="cart-drawer__taxes">
          <p class="cart-drawer__taxes-note">
            Taxes and shipping calculated at checkout.
          </p>
        </div>

      </div>
    `;

    // agcd-fix r3 (2026-08-16, A): the checkout block leaves the totals box and becomes the
    // form's LAST child, so its sticky containing block spans the whole scroll content -
    // content scrolls out first, the pinned checkout settles last.
    const agCheckoutBlock = document.createElement('div');
    agCheckoutBlock.className = 'cart-drawer__checkout';
    agCheckoutBlock.innerHTML = `
      <div class="cart-drawer__shipping-message">
        You Qualify for Free Shipping Now!
      </div>
      <button type="submit" class="cart-drawer__checkout-button button button--primary" name="add" aria-haspopup="dialog">
        CHECKOUT - ${this.formatMoney(cart.total_price).replace(/\.00$/, '')}
      </button>

      <!-- Dynamic Checkout Buttons -->
      <div class="cart-drawer__dynamic-checkout">
        <!-- Dynamic checkout buttons will be loaded here -->
      </div>
    `;
    
    // agcd-fix: swap the empty placeholder for the preserved wallet block (keeps the web
    // component alive -> zero re-hydration flash, zero extra /cart fetches)
    if (this._agWalletKeep) {
      const agSlot = agCheckoutBlock.querySelector('.cart-drawer__dynamic-checkout'); // agcd-fix r3
      if (agSlot) {
        agSlot.replaceWith(this._agWalletKeep);
      }
      this._agWalletKeep = null;
    }

    this._agwgStamp(footer, cart);
    // Assemble the form
    cartForm.appendChild(cartItemsContainer);
    cartForm.appendChild(footer);
    cartForm.appendChild(agCheckoutBlock); // agcd-fix r3: sticky checkout = form's last child
    
    // Add form to cart content
    cartContent.appendChild(cartForm);
    
    // Store references
    this.cartForm = cartForm;
    this.cartItems = cartItemsContainer;
    
    // Bind submit handler
    this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    
    // Bind cart note change handler for real-time saving
    const cartNoteTextarea = footer.querySelector('#cart-drawer-note');
    if (cartNoteTextarea) {
      cartNoteTextarea.addEventListener('input', this.handleCartNoteChange.bind(this));
    }
    
    console.log('Created complete cart structure with checkout button');
    
    // Verify the button was created
    const checkoutButton = agCheckoutBlock.querySelector('.cart-drawer__checkout-button'); // agcd-fix r3
    console.log('Checkout button created:', checkoutButton);
    
    // Re-setup event listeners for new items
    this.setupQuantityControls();
    this.setupRemoveButtons();
    
    // Load and initialize payment buttons in cart drawer
    this.loadDynamicCheckoutButtons();
  }

  async loadDynamicCheckoutButtons() {
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('No payment wrapper found, skipping checkout buttons load');
      return;
    }

    // agcd-fix: reuse — if the wallet component is already present (preserved across rebuilds
    // or injected earlier) never re-fetch; re-hydration IS the late pop-in this fix removes.
    if (paymentWrapper.querySelector('shopify-accelerated-checkout-cart')) {
      paymentWrapper.style.display = '';
      return;
    }
    // agcd-fix: single-flight — the /cart scrape is a ~547KB document; concurrent rebuild
    // calls share one in-flight fetch instead of firing it repeatedly.
    if (this._agWalletFetch) {
      return this._agWalletFetch;
    }
    this._agWalletFetch = this._agFetchWalletButtons().finally(() => { this._agWalletFetch = null; });
    return this._agWalletFetch;
  }

  async _agFetchWalletButtons() {
    // agcd-fix: re-resolve the wrapper at inject time so a rebuild mid-fetch can't strand the
    // injected markup on a detached node.
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      return;
    }

    try {
      // Fetch the cart page which should have the checkout buttons
      const response = await fetch('/cart');
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Look for checkout buttons in the cart page
      // They might be in a form or in a specific container
      let checkoutButtons = doc.querySelector('#dynamic-checkout-cart, .dynamic-checkout__content');
      
      // If not found, try to find shopify-accelerated-checkout-cart component
      if (!checkoutButtons) {
        checkoutButtons = doc.querySelector('shopify-accelerated-checkout-cart');
      }
      
      // If still not found, look for the wrapper
      if (!checkoutButtons) {
        const wrapper = doc.querySelector('.shop-pay-button-wrapper, .cart-drawer__dynamic-checkout');
        if (wrapper) {
          checkoutButtons = wrapper.querySelector('shopify-accelerated-checkout-cart, #dynamic-checkout-cart, .dynamic-checkout__content') || wrapper;
        }
      }
      
      if (checkoutButtons && checkoutButtons.innerHTML.trim()) {
        // Get the inner HTML or outer HTML depending on what we found
        const buttonsHTML = checkoutButtons.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART' 
          ? checkoutButtons.outerHTML 
          : checkoutButtons.innerHTML;
        
        paymentWrapper.innerHTML = buttonsHTML;
        console.log('Loaded dynamic checkout buttons HTML');
        
        // Wait a bit for the web component to initialize
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 200);
      } else {
        console.log('No checkout buttons found, hiding wrapper');
        paymentWrapper.style.display = 'none';
      }
    } catch (error) {
      console.error('Error loading checkout buttons:', error);
      paymentWrapper.style.display = 'none';
    }
  }

  renderCartItem(item, index) {
    const image = item.image ? 
      `<img src="${item.image}" alt="${item.image.alt || item.title}" class="cart-drawer__item-image-img" width="150" height="150" loading="lazy">` : 
      '';

    const variantTitle = '';

    return `
      <div class="cart-drawer__item" id="cart-drawer-item-${index}">
        <div class="cart-drawer__item-image">
          ${image}
        </div>
        <div class="cart-drawer__item-details">
          <h3 class="cart-drawer__item-title">
            <a href="${item.url}" class="cart-drawer__item-link">${item.title}</a>
          </h3>
          <div class="cart-drawer__item-price">
            ${item.original_price !== item.final_price ? 
              `<s class="cart-drawer__item-price-regular">${this.formatMoney(item.original_price).replace(/\.00$/, '')}</s>
               <strong class="cart-drawer__item-price-final">${this.formatMoney(item.final_price).replace(/\.00$/, '')}</strong>` :
              this.formatMoney(item.original_price).replace(/\.00$/, '')
            }
          </div>
          ${variantTitle}
          ${(function (props) {
            /* agwc R13 (A: "The drawer pop up, should state whether it is left or
               right as well"). This drawer rebuilds every line on load and so wiped
               the server-rendered property row of snippets/cart-drawer.liquid:64-90,
               the only surface on this theme that printed one. Same markup, same
               classes, from the /cart.js payload: a private key (leading underscore)
               and a blank value are skipped exactly as the Liquid skips them, an
               /uploads/ value keeps its download link, and every string is escaped
               (the Liquid's {{ }} is raw). */
            var esc = function (s) {
              return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
            };
            var rows = '';
            Object.keys(props || {}).forEach(function (name) {
              var value = props[name];
              if (String(name).charAt(0) === '_') { return; }
              if (typeof value !== 'string' || value.trim() === '') { return; }
              var body = value.indexOf('/uploads/') >= 0
                ? '<a href="' + esc(value) + '" class="link" target="_blank">'
                    + esc(value.split('/').pop()) + '</a>'
                : esc(value);
              rows += '<div class="cart-drawer__item-option"><dt>' + esc(name)
                + ':</dt><dd>' + body + '</dd></div>';
            });
            return rows
              ? '<dl class="cart-drawer__item-options">' + rows + '</dl>'
              : '';
          })(item.properties)}
          <div class="cart-drawer__item-quantity">
            <div class="quantity">
              <button class="quantity__button quantity__button--minus" type="button" name="minus">
                <svg class="icon icon-minus" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.8.5 1 .5h8c.3 0 .5.2.5.5s-.2.5-.5.5H1C.8 2 .5 1.8.5 1z" fill="currentColor">
                </svg>
              </button>
              <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" data-index="${index}">
              <button class="quantity__button quantity__button--plus" type="button" name="plus">
                <svg class="icon icon-plus" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49 1a.5.5 0 00-1 .01v3.5L1 4.51z" fill="currentColor">
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="cart-drawer__item-remove">
          <button type="button" class="cart-drawer__item-remove-button">
            <svg class="icon icon-remove" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  updateTotals(cart) {
    console.log('updateTotals called with cart:', cart);
    console.log('cart.total_price:', cart.total_price);
    
    const subtotalElement = this.querySelector('.cart-drawer__subtotal-price');
    if (subtotalElement) {
      subtotalElement.textContent = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      console.log('Updated subtotal to:', this.formatMoney(cart.total_price));
    }
    
    // Update checkout button price
    const checkoutButton = this.querySelector('.cart-drawer__checkout-button');
    console.log('Found checkout button:', checkoutButton);
    if (checkoutButton) {
      const formattedPrice = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      const newText = `CHECKOUT - ${formattedPrice}`;
      checkoutButton.textContent = newText;
      console.log('Updated checkout button to:', newText);
    } else {
      console.log('Checkout button not found!');
    }
  }

  updateCartCount(cart) {
    const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
    });
  }

  // ---- agwg start: white glove eligibility for the cart callout --------------
  // The callout above is re-emitted on every rebuild, but WHETHER it may claim
  // availability depends on what is in the cart. Rule T (A's ruling): a product is
  // eligible when it carries one of three EXACT tags, and any Prod_Quickship tag
  // disqualifies it outright (quickship has priority, mirroring the PDP badge
  // chain). Untagged or unresolved is NOT eligible.
  //
  // TRUTHFUL DEFAULT IS HIDE. The markup ships in the unknown state and the
  // stylesheet hides unknown + none, so a cart whose eligibility cannot be
  // established shows nothing rather than a claim we cannot stand behind. The
  // callout can therefore only ever APPEAR late - it never swaps copy in front of
  // a customer, and it never retracts a claim it has already made.
  //
  // Channel: /products/<handle>.js, which returns the product's tags. Measured
  // 2026-08-15: cf-cache-status DYNAMIC, 104-153 ms - NOT CDN-cached, so the
  // sessionStorage cache, the single-flight map and the handle dedupe are
  // load-bearing rather than optimisations. A missing handle 404s with an EMPTY
  // body, so .json() throws and lands in the unresolved path by design.

  _agwgClassify(tags) {
    var i;
    if (!tags || !tags.length) { return 0; }
    // Quickship first - it outranks every other tag.
    for (i = 0; i < tags.length; i++) {
      if (tags[i] === 'Prod_Quickship') { return 0; }
    }
    // EXACT equality only. Live products carry overlapping-prefix tags such as
    // Customization_Customizable next to Prod_Overseas In-Stock, so a substring or
    // startsWith test would misclassify them.
    for (i = 0; i < tags.length; i++) {
      if (tags[i] === 'Prod_Customizable' ||
          tags[i] === 'Prod_Made to Order' ||
          tags[i] === 'Prod_Overseas In-Stock') { return 1; }
    }
    return 0;
  }

  _agwgCache() {
    if (this._agwgMem) { return this._agwgMem; }
    var raw = null, map = {};
    try { raw = window.sessionStorage.getItem('agwg_ft_v1'); } catch (e) { raw = null; }
    if (raw) { try { map = JSON.parse(raw) || {}; } catch (e) { map = {}; } }
    this._agwgMem = map;
    return map;
  }

  _agwgRemember(handle, value) {
    var map = this._agwgCache(), keys, i;
    map[handle] = value;
    keys = Object.keys(map);
    // Bounded: a long browsing session must not grow this without limit.
    if (keys.length > 200) {
      for (i = 0; i < keys.length - 200; i++) { delete map[keys[i]]; }
    }
    this._agwgMem = map;
    // Every storage touch is guarded: a throw here runs inside the rebuild path
    // and would take the note field and checkout button down with it.
    try { window.sessionStorage.setItem('agwg_ft_v1', JSON.stringify(map)); } catch (e) {}
  }

  _agwgHandles(cart) {
    var out = [], seen = {}, items = (cart && cart.items) || [], i, h;
    for (i = 0; i < items.length; i++) {
      h = items[i] && items[i].handle;
      if (h && !seen[h]) { seen[h] = 1; out.push(h); }
    }
    return out;
  }

  _agwgFetch(handle) {
    var self = this;
    if (!this._agwgFlight) { this._agwgFlight = new Map(); }
    if (this._agwgFlight.has(handle)) { return this._agwgFlight.get(handle); }
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js',
                  { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { throw new Error('agwg status ' + r.status); }
        return r.json();
      })
      .then(function (d) {
        // A missing tags key is UNRESOLVED, never "no tags" - the difference is a
        // hidden callout versus a false one.
        if (!d || !Array.isArray(d.tags)) { throw new Error('agwg no tags'); }
        var v = self._agwgClassify(d.tags);
        self._agwgRemember(handle, v);
        return v;
      })
      .catch(function () { return null; })
      .finally(function () { self._agwgFlight.delete(handle); });
    this._agwgFlight.set(handle, p);
    return p;
  }

  _agwgPaint(seq, handles, node) {
    if (seq !== this._agwgSeq) { return; }
    // Re-query from whatever is live. Holding the footer node across an await is
    // how the wallet fix stranded markup on a detached tree; the async repaint
    // therefore looks the element up again instead of closing over it.
    var el = node ? node.querySelector('.agwg-cartline')
                  : this.querySelector('.agwg-cartline');
    if (!el) { return; }
    var map = this._agwgCache(), elig = 0, other = 0, unres = 0, i, v;
    for (i = 0; i < handles.length; i++) {
      v = map[handles[i]];
      if (typeof v === 'undefined') { unres++; }
      else if (v === 1) { elig++; }
      else { other++; }
    }
    var state = 'none';
    if (elig > 0) { state = (other === 0 && unres === 0) ? 'all' : 'some'; }
    el.setAttribute('data-agwg-state', state);
    // D1 (A's pick, 2026-08-15): the LABEL carries the qualification. Same
    // element, same register, caps either way - only the string changes, and
    // only in the mixed state. It is restated on every paint rather than only
    // when mixed, so a cart that goes some -> all (remove the ineligible line)
    // returns to the unqualified claim without a reload.
    var lab = el.querySelector('.agwg-cartline-label');
    if (lab) {
      lab.textContent = (state === 'some')
        ? 'WHITE GLOVE DELIVERY AVAILABLE FOR SELECT ITEMS'
        : 'WHITE GLOVE DELIVERY AVAILABLE';
    }
  }

  _agwgStamp(footer, cart) {
    var self = this;
    // Monotonic sequence: a rebuild that lands while a fetch is in flight makes
    // the older resolver a no-op instead of letting it stamp a stale cart's answer.
    var seq = (this._agwgSeq = (this._agwgSeq || 0) + 1);
    var handles = this._agwgHandles(cart);
    var map = this._agwgCache(), pending = [], jobs = [], i;
    for (i = 0; i < handles.length; i++) {
      if (typeof map[handles[i]] === 'undefined') { pending.push(handles[i]); }
    }
    // Synchronous paint against the node about to be attached: a warm cache
    // resolves before the first frame, so repeat opens never show a flash.
    this._agwgPaint(seq, handles, footer);
    if (!pending.length) { return; }
    for (i = 0; i < pending.length; i++) { jobs.push(this._agwgFetch(pending[i])); }
    Promise.all(jobs).then(function () { self._agwgPaint(seq, handles); });
  }

  _agwgWarm(cart) {
    // Fire-and-forget on every cart refresh so the NEXT open can stamp
    // synchronously. Deliberately unawaited - it must never delay the drawer.
    var handles = this._agwgHandles(cart), map = this._agwgCache(), i;
    for (i = 0; i < handles.length; i++) {
      if (typeof map[handles[i]] === 'undefined') { this._agwgFetch(handles[i]); }
    }
  }
  // ---- agwg end --------------------------------------------------------------

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  async open() {
    console.log('CartDrawer.open() called');
    console.log('Drawer element:', this.drawer);
    console.log('Adding cart-drawer--open class');
    
    this.drawer.classList.add('cart-drawer--open');
    document.body.classList.add('cart-drawer-open');
    
    console.log('Classes added, drawer should be visible now');
    
    // Refresh cart data when opening
    try {
      const cart = await this.refreshCart();
      console.log('Cart refreshed on open, items:', cart?.items?.length || 0);
      
      // If cart has items, ensure all elements are properly displayed
      if (cart && cart.items.length > 0) {
        console.log('Cart has items, ensuring proper display');
        // Force a re-render to ensure all elements are visible
        setTimeout(() => {
          this.showCartItems(cart);
          this.updateTotals(cart);
        }, 100);
      }
    } catch (error) {
      console.error('Error refreshing cart on open:', error);
    }
    
    // Initialize payment buttons after cart is refreshed
    setTimeout(() => {
      this.initializePaymentButtons();
    }, 300);
    
    // Focus first focusable element
    const firstFocusable = this.drawer.querySelector('button, input, a');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  initializePaymentButtons() {
    console.log('Initializing payment buttons in cart drawer...');
    
    // First check if cart is empty - don't initialize if empty
    const cartContent = this.querySelector('.cart-drawer__content');
    const isEmpty = this.drawer.classList.contains('cart-drawer--empty') || 
                    !cartContent || 
                    cartContent.querySelector('.cart-drawer__empty');
    
    if (isEmpty) {
      console.log('Cart is empty, skipping payment button initialization');
      // Hide any existing payment buttons
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper) {
        paymentWrapper.style.display = 'none';
      }
      return;
    }
    
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('No payment wrapper found in cart drawer');
      return;
    }
    
    // Ensure wrapper is visible only if cart has items
    paymentWrapper.style.display = 'block';
    paymentWrapper.style.opacity = '1';
    
    // Remove any skeleton loaders that might be stuck
    const skeletons = paymentWrapper.querySelectorAll('.shopify-payment-button__skeleton, .wallet-cart-button__skeleton');
    skeletons.forEach(skeleton => {
      skeleton.style.display = 'none';
      console.log('Removed cart drawer payment button skeleton');
    });
    
    // Hide skeleton loaders in shopify-accelerated-checkout-cart component
    const checkoutCart = paymentWrapper.querySelector('shopify-accelerated-checkout-cart');
    if (checkoutCart) {
      const walletSkeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton');
      walletSkeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
      
      // Ensure the component itself is visible
      checkoutCart.style.display = 'block';
    }
    
    // Initialize Shopify payment buttons if available
    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      try {
        console.log('Calling Shopify.PaymentButton.init() for cart drawer');
        Shopify.PaymentButton.init();
        console.log('Cart drawer payment buttons initialized');
      } catch (error) {
        console.error('Error initializing cart drawer payment buttons:', error);
      }
    } else {
      console.log('Shopify.PaymentButton not available, will try again...');
      // Try again after a delay
      setTimeout(() => this.initializePaymentButtons(), 500);
    }
  }

  close() {
    console.log('CartDrawer.close() called');
    this.drawer.classList.remove('cart-drawer--open');
    document.body.classList.remove('cart-drawer-open');
    console.log('Cart drawer closed');
  }

  isOpen() {
    return this.drawer.classList.contains('cart-drawer--open');
  }

  connectedCallback() {
    // Called when the element is inserted into the DOM
    console.log('Cart drawer connected to DOM');
    
    // Initialize checkout buttons if cart has items and buttons are already rendered
    setTimeout(() => {
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper && paymentWrapper.querySelector('shopify-accelerated-checkout-cart')) {
        // Check if cart has items
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart && cart.items.length > 0) {
              console.log('Initializing checkout buttons on connect (cart has items)');
              this.showDynamicCheckoutButtons();
              this.initializePaymentButtons();
            }
          })
          .catch(error => {
            console.error('Error checking cart on connect:', error);
          });
      }
    }, 100);
  }
}

customElements.define('cart-drawer', CartDrawer);
